import { ActivityEventType, type ActivityFeedRow } from '../schemas'

/**
 * A row's React key. Unique within a response: the feed holds one row per chat, one per draft, one per table, and
 * at most one generated and one updated row per record type. A draft keeps its key when the event
 * moves from generated to updated.
 */
export function activityRowKey(row: ActivityFeedRow): string {
  switch (row.event) {
    case ActivityEventType.ChatUpdated:
      return `chat:${row.conversation_id}`
    case ActivityEventType.DraftGenerated:
    case ActivityEventType.DraftUpdated:
      return `draft:${row.artifact_id}`
    case ActivityEventType.TableCreated:
    case ActivityEventType.TableUpdated:
      return `table:${row.table_id}`
    case ActivityEventType.RecordGenerated:
    case ActivityEventType.RecordUpdated:
      return `${row.event}:${row.record_type}`
    default: {
      const _exhaustive: never = row
      return _exhaustive
    }
  }
}
